module.exports = __webpack_public_path__ + "img/dark RGB.ebc19497.png";